import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { LotteryDrawn } from "../../_shared/models/lottery-draw.model";
import { TaskQueue, LotteryDrawTask } from "../../_shared/models/task-queue.model";
import { ICollectionReference } from '../database-cast/IDatabase';


export class DbLotteryDraws extends DbListBase<LotteryDrawn> {

  
    constructor(collection: ICollectionReference) {
        super(collection);
       
    }

  public getLotteryDraw(id: string): DbLotteryDraw {
    return new DbLotteryDraw(id,this._collection);
  }
}

export class DbLotteryDraw extends DbObjectBase<LotteryDrawn>
{
 
  getResults(): DbLotteryDrawResults {
    return new DbLotteryDrawResults(this._docReference.collection("results"));
  }
    
  getTasks(): DbLotteryDrawTasks {
    return new DbLotteryDrawTasks(this._docReference.collection("tasks"));
  }

}

export class DbLotteryDrawResults extends DbListBase<any>
{
 
  public  getResult(id: string): DbLotteryDrawResult {
    return new DbLotteryDrawResult(id,this._collection);
  }

}

export class DbLotteryDrawResult extends DbObjectBase<any> {

  constructor(id: string, colllection: ICollectionReference) {
     super(id,colllection)

  }

}


export class DbLotteryDrawTasks extends DbListBase<LotteryDrawTask>
{
 
    
}
